import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { useLocation } from 'react-router-dom';

export const usePageTracking = ({ isEnabled }: { isEnabled: boolean }) => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!isEnabled) {
      return;
    }

    ReactGA.send({ hitType: 'pageview', page: pathname });
  }, [pathname, isEnabled]);
};
